module.exports = __webpack_public_path__ + "img/OBUHaveOrder_03.8635d750.png";